import request from '../request';
import {
  ORGANIZATION_MEMBERSHIP_ADMIN,
  ORGANIZATION_MEMBERSHIP_COURSE_CREATOR,
} from '../reducer/organizationMembership';

let getApiPath = role => `/manage/organization/${role}-memberships/`;
let getRoleName = () => JSON.parse(localStorage.getItem('permission'))?.role?.name;
let roleName = getRoleName();

/**#################### Admin resource ####################*/
export function organizationMembershipAdminList(params = {}) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.list.loading });

      let res = await request.get(getApiPath('admin'), { params: { ...params } });
      let { results, count } = res.data;
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.list.error, payload: e.response.data });
    }
  };
}

export function organizationMembershipAdminDelete(id) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.loading });

      await request.delete(`${getApiPath('admin')}${id}`);

      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.delete, payload: id });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.error, payload: e.response.data });
    }
  };
}

export function organizationMembershipAdminCreate(data) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.loading });

      let res = await request.post(getApiPath('admin'), data);

      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.create, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.error, payload: e.response.data });
    }
  };
}

export function organizationDeleteMembership(id, selectedRole) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.loading });

      await request.delete(`${getApiPath(selectedRole)}${id}`);

      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.delete, payload: id });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_ADMIN.error, payload: e.response.data });
    }
  };
}

/**#################### Course creator resource ####################*/
export function organizationMembershipCourseCreatorList(params = {}) {
  if (roleName) roleName = getRoleName();

  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.loading });

      let res = await request.get(getApiPath('course-creator'), { params: { ...params } });
      let { results, count } = res.data;
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.list.error, payload: e.response.data });
    }
  };
}

export function organizationMembershipCourseCreatorDelete(id) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.loading });

      await request.delete(`${getApiPath('course-creator')}${id}`);

      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.delete, payload: id });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.error, payload: e.response.data });
    }
  };
}

export function organizationMembershipCourseCreatorCreate(data) {
  return async dispatch => {
    try {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.loading });

      let res = await request.post(getApiPath('course-creator'), data);
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.create, payload: res.data });
    } catch (e) {
      dispatch({ type: ORGANIZATION_MEMBERSHIP_COURSE_CREATOR.error, payload: e.response.data });
    }
  };
}
